import createIcon from '../../createIcon';

/**
 * @component @name ThumbDownOffAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuODkgMTcuMjhMMTEuNDYgMTQuMzlDMTEuNTggMTMuOCAxMS40MiAxMy4xOSAxMS4wNCAxMi43M0MxMC42NiAxMi4yNyAxMC4xIDEyIDkuNSAxMkg0VjEwLjkyTDYuNTcgNUgxNC42NkMxNC44NCA1IDE1IDUuMTYgMTUgNS4zNFYxMy4xOEwxMC44OSAxNy4yOFpNMTAgMjFMMTYuNDEgMTQuNTlDMTYuNzkgMTQuMjEgMTcgMTMuNyAxNyAxMy4xN1Y1LjM0QzE3IDQuMDUgMTUuOTUgMyAxNC42NiAzSDYuNTZDNS44NSAzIDUuMiAzLjM3IDQuODQgMy45N0wyLjE3IDEwLjEyQzIuMDYgMTAuMzcgMiAxMC42NCAyIDEwLjkyVjEyQzIgMTMuMSAyLjkgMTQgNCAxNEg5LjVMOC41OCAxOC42NUM4LjUzIDE4Ljg3IDguNTYgMTkuMTEgOC42NiAxOS4zMUM4Ljg5IDE5Ljc2IDkuMTggMjAuMTcgOS41NCAyMC41M0wxMCAyMVpNMjAgMTRIMjJWM0gyMEMxOS40NSAzIDE5IDMuNDUgMTkgNFYxM0MxOSAxMy41NSAxOS40NSAxNCAyMCAxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbDownOffAlt = createIcon('ThumbDownOffAlt', [
  [
    'path',
    {
      d: 'M10.89 17.28L11.46 14.39C11.58 13.8 11.42 13.19 11.04 12.73C10.66 12.27 10.1 12 9.5 12H4V10.92L6.57 5H14.66C14.84 5 15 5.16 15 5.34V13.18L10.89 17.28ZM10 21L16.41 14.59C16.79 14.21 17 13.7 17 13.17V5.34C17 4.05 15.95 3 14.66 3H6.56C5.85 3 5.2 3.37 4.84 3.97L2.17 10.12C2.06 10.37 2 10.64 2 10.92V12C2 13.1 2.9 14 4 14H9.5L8.58 18.65C8.53 18.87 8.56 19.11 8.66 19.31C8.89 19.76 9.18 20.17 9.54 20.53L10 21ZM20 14H22V3H20C19.45 3 19 3.45 19 4V13C19 13.55 19.45 14 20 14Z',
      key: '2lukwy',
    },
  ],
]);

export default ThumbDownOffAlt;
